import React, { FunctionComponent, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import axios from 'axios';
import Loading from '../../Components/Loading/Loading';
import ApiCustomTable from "../../Components/CustomTable/ApiCustomTable";
import { getDateFromISOString, getTimeFromISOString } from "../../Values/utils";
import { googleAnalytics } from '../../Services/users';
import axiosHandler from '../../Services/axiosHandler';
import { themeColors } from '../../Components/theme';
import { url, contactFilterValues } from '../../Values/constants';
import {
  DELETED_LOGS_COLUMN,
  datesField,
  booleanObject,
} from "../../Values/tables";
import styles from "../Settings/Settings.module.css";
import "./AuditLog.css";
import moment from "moment";
import Firebase from "firebase/app";
import {
  setFilterObject,
  setRefreshContacts,
  showSnackbarAction,
  clearAllFilters,
  setCurrentRoute
} from "../../Redux/actions";
import DeleteSelectedModalSoftDelete from "../../Components/Modals/DeleteSelectedModal/DeleteSelectedModalSoftDelete";
import{getDeletedContactsFilter} from "../../Services/contacts"
import DeleteContact from './DeleteContact';
import InfoIcon from '@mui/icons-material/Info';

type Props = {
  user: any;
  authToken: any;
  theme:any;
 
};

const AuditLogs: FunctionComponent<Props> = ({
  user,
  theme,
  authToken,
   }) => {
  let dispatcher = useDispatch();
  const history = useHistory();
  let isFinished = false;
  const [data, setData] = useState<any[]>([]);
  const [load, setLoad] = useState<boolean>(false);
  const [isGACalled, setIsGACalled] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>('deletedContacts');
  
  const [selectedData,setSelectedData] = useState<any[]>([]);
  const [selectedRow,setSelectedRow] = useState<any[]>([]);
  // const [selectedRow,setSelectedRow] = useState<any[]>([]);
  const [show, setShow] = useState(false);

  const [deletePopup, setDeletePopop] = useState(false);
   const [cRoute,setCRoute]=useState("") 
         const location: any = useLocation();                    
                            useEffect(() => {
                              dispatcher(setCurrentRoute(location.pathname))
                              setCRoute(location.pathname)
                            }, [location]);
  useEffect(() => {
    if(selectedRow){
      if (selectedRow.length !== 0) {
        setShow(true)
      } else {
        setShow(false)
      }
    }
  }, [selectedRow])


  const clearSelectedRowsData = () => {
    setSelectedData([]);
    setSelectedRow([]);
  };


  useEffect(() => {
    if (!isGACalled && user?.uid && user?.profile) {
      setIsGACalled(true);
      googleAnalytics('Audit_Log_Screen', user);
    }
  }, [user, isGACalled]);

  const fetchData = async () => {
    setLoad(true);
    try {
      const res = await axiosHandler.post(`${url}/auditLogs/fetchExportLogs`, {
        organization_id: user.organization_id,
      });
      setData(res.data.data);
    } catch (error) {
      console.error("Error fetching audit logs", error);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (authToken && user) {
      fetchData();
    }
  }, [authToken, user]);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const containerStyles = {
    backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const buttonStyles = {
    backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  // console.log("rishabh audit logs",selectedRows)

  return (
    <div className={styles.parent} style={containerStyles}>
      {load && <Loading />}
      <div className="w-100 d-flex flex-column gap-2 px-4 pt-4">
        {show && (
          <div
            className={styles.statusBox}
            style={{ marginLeft: '10px', borderWidth: '0px' }}
          >
            <h6
              className={styles.owner}
              style={{  cursor: "pointer" }}
              onClick={() => {
                // Add your click handler logic here
                setDeletePopop(true)
                // clearSelectedRowsData && clearSelectedRowsData()
              }}
            >
              Restore Records
            </h6>
          </div>
        )}

        <form className="card p-4 shadow rounded mt-2">
          <div className="d-flex gap-2 align-items-center">
            <InfoIcon />
            <p className="mb-0">
              Contacts deleted within the last 30 days can be restored here
            </p>
          </div>

          <div>
            <button
              type="button"
              style={{ float: "left", ...buttonStyles }}
              onClick={() => handleTabChange('deletedContacts')}
              className={`export mx-4 ${activeTab === "deletedContacts" ? "active" : ""}`}
            >
              Deleted Contacts
            </button>
            <button
              type="button"
              style={{ float: "left", ...buttonStyles }}
              onClick={() => handleTabChange('exportLogs')}
              className={`export mx-4 ${activeTab === "exportLogs" ? "active" : ""}`}
            >
              Export Logs
            </button>

          </div>
          {activeTab === 'deletedContacts' ? (
            
            <DeleteContact
            setSelectedRow={(val)=>setSelectedRow(val)}
            setSelectedData={(val)=>setSelectedData(val)}
            setLoad={setLoad}

            />

          ) : (
            <table id="auditLog">
              <thead>
                <tr>
                  <th style={{ width: "10rem" }}>Date</th>
                  <th style={{ width: "10rem" }}>Time</th>
                  <th style={{ width: "90rem" }}>Export Log</th>
                </tr>
              </thead>
              <tbody>
                {data.filter(item => item.operation_type === "Export").map(item => (
                  <tr key={item.id}>
                    <td style={{ width: "10rem" }}><b>{getDateFromISOString(item.created_at)}</b></td>
                    <td style={{ width: "10rem" }}><b>{getTimeFromISOString(item.created_at)}</b></td>
                    <td style={{ width: "90rem" }}>{item.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </form>
        {deletePopup && (
          <DeleteSelectedModalSoftDelete
            data={selectedData}
            clearSelectedRowsData={clearSelectedRowsData}
            open={deletePopup}
            history={history}
            close={() => {
              setDeletePopop(false);
            }}
            panel="DeletedLogs"
            selectedRows={selectedRow}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user.data,
  theme: state.theme.isLightMode,
  authToken: state.user.authToken,
  role: state.user.role,
  contacts: state.contacts,
  organizationUsers: state.organizationUsers.data,
  teamLeadUsers: state.teamLeadUsers.data,
  // filterObject: state.filter,
  // filterSort: state.filterSort,
  filterObject: state.deleteLogsFilterObj,
  filterSort: state.deleteLogsSortObj,
  refreshContacts: state.refresh.refreshContacts,
  searchString: state.searchItem.contactsSearchString,
  organizationData: state.organization.organizationData,
});

export default connect(mapStateToProps)(AuditLogs);
